// extracted by mini-css-extract-plugin
module.exports = {"minimumScreenWidth":"320px","mobileScreenWidth":"600px","root":"style_root__y6IHS","img":"style_img__3K-GA","text":"style_text__1ZbJB"};